module.exports = __webpack_public_path__ + "static/media/rails.1a1bf99a.svg";